import { useQuery } from "react-query";
import LeaderboardService from "@/services/leaderboard.service";

export const useLeaderboard = (page: number, searchQuery: string) => {
    return useQuery({
        queryKey: ["leaderboard", page, searchQuery],
        queryFn: () => LeaderboardService.getLeaderboard({ page, limit: 10, search: searchQuery }).then(res => res.data),
        keepPreviousData: true,
        staleTime: 1000 * 5,
        retry: false, 
    });
};